import { Form } from 'factorial-form'

class User extends Form {
  constructor(values: {}) {
    super(values, {
      id: 'number',
      email: 'string',
      first_name: 'string',
      last_name: 'string',
      invited_on: 'date',
      unconfirmed_email: 'any',
      avatar: 'file',
      permissions_group_id: 'number',
    })
  }
}

export default User
